import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const HEENT_FORM_INITIAL_VALUES = {
  sections: {
    head: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    eyes: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    ears: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    nose: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    mouth: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    teethGums: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    pharynx: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    neck: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamHEENTSections = keyof typeof HEENT_FORM_INITIAL_VALUES.sections;
